import { Http } from "../axios/interceptors";

export const allServices = async (param) =>
  Http("GET", `/Services/GetList?`, param);

export const allServicesByCompanie = async (guid) =>
  Http("GET", `/Services/GetByCompany?guidCompany=${guid}`);

export const getService = async (guid) =>
  Http("GET", `/Services/Get?guid=${guid}`);

export const getCalendarAvailability = async (param) =>
  Http("GET", "/Services/GetListCalendarAvailability?", param);

export const createOrEditService = async (body, id = null) =>
  id
    ? Http("PUT", `/Services/Update`, null, body)
    : Http("POST", "/Services/Create", null, body);

export const inactiveService = async (guid) =>
  Http("PUT", `/Services/Inactive?guid=${guid}`);

export const activeService = async (guid) =>
  Http("PUT", `/Services/Active?guid=${guid}`);

export const deleteCalendarAvailability = async (guid) =>
  Http("PUT", `/DeleteCalendarAvailability?idAvailability=${guid}`);
